﻿import {NamedValue} from "@2d-front-monorepo/core";
import {DriverId} from "../nominalTypes/DriverId";
import {ResidencyId} from "../nominalTypes/ResidencyId";
import {VehicleId} from "../nominalTypes/VehicleId";

/**
 * El pre-seleccionado manda (renovación, visitante, draft). Si no hay ninguno válido cae en el
 * primer ítem de la lista - que es "Add new" cuando la creación está habilitada, porque
 * {@link useCreateSelectItems} lo pushea al frente: obliga al usuario a elegir en vez de arrastrar
 * la primera entidad del holder sin mirarla.
 */
export default function selectOrCreate<T extends DriverId | ResidencyId | VehicleId>(collection: NamedValue<T>[], selected: T): T {
	const preSelected = collection.find(x => x.value === selected);
	if (preSelected != null) return preSelected.value;

	return collection[0]?.value ?? ("create" as T);
}
